import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$locale/admin/ai-metrics')({
  ssr: false,
});
